export const MOT_CHECK_STATUS_CODES = {
  INVALID_VRM: 424,
  NOT_FOUND: 404,
  STATUS_PENDING: 202,
  STATUS_SUCCESS: 200,
  TECHNICAL_DIFFICULTIES: 500,
} as const;
